<template>
  <div class="gallery-panel">
    <Post
      class="pa-6"
      :item="post"
      isMedia
      @onData="onData"
    />
  </div>
</template>

<script>
import Post from "@/components/Post/Post.vue"; // post card
export default {
  name: "GalleryPanel",
  components: {
    Post,
  },
  props: {
    mediaDetail: { type: Object, default: {} },
  },
  data() {
    return {
      post: {},
    };
  },
  watch: {
    mediaDetail: {
      immediate: true,
      handler(val) {
        if (val && val.comments) {
          let comments = val.comments.list || [];
          this.post = { ...val, comments };
        }
      },
    },
  },
  methods: {
    // create , update, delete
    onData(item) {
      if (item.mode === "update") {
        delete item.mode;
        this.post = { ...this.post, ...item };
      }
      return;
    },
  },
};
</script>